// "Remind me later" snoozes the pop-up for one invoice for a while, not for
// good: after REMIND_LATER_HOURS it opens again. While snoozed, a slim
// "payment due" bar keeps the bill one click away (see due-banner.tsx).
export const REMIND_LATER_HOURS = 24

const KEY_PREFIX = 'cellularPayPrompt.remindLater.'

const keyFor = (invoiceId: string) => `${KEY_PREFIX}${invoiceId}`

export const isRemindedLater = (invoiceId: string, now: number = Date.now()): boolean => {
  try {
    const until = Number(window.localStorage.getItem(keyFor(invoiceId)))
    return Number.isFinite(until) && until > now
  } catch (error) {
    return false
  }
}

export const rememberRemindLater = (invoiceId: string, now: number = Date.now()): void => {
  try {
    window.localStorage.setItem(keyFor(invoiceId), String(now + REMIND_LATER_HOURS * 3600 * 1000))
  } catch (error) {
    // Storage can be unavailable (private mode, blocked site data); the dialog just closes for now.
  }
}

// A back-bill invoice is replaced whenever it is refinalized, so snoozes for other
// invoices are dead weight — and must never be able to silence the current one.
export const forgetOtherInvoices = (invoiceId: string): void => {
  try {
    const storage = window.localStorage
    Object.keys(storage)
      .filter(key => key.startsWith(KEY_PREFIX) && key !== keyFor(invoiceId))
      .forEach(key => storage.removeItem(key))
  } catch (error) {
    // Storage can be unavailable; stale keys are harmless.
  }
}
